import React from 'react'
import * as Styled from './ChatActionItem.styles'

interface ChatActionItemProps {
  icon: React.ReactNode
  label: string
  onClick: () => void
}

const ChatActionItem: React.FC<ChatActionItemProps> = ({ icon, label, onClick }) => (
  <Styled.StyledMenuItem onClick={onClick}>
    <Styled.StyledListItemIcon>{icon}</Styled.StyledListItemIcon>
    <Styled.StyledListItemText>{label}</Styled.StyledListItemText>
  </Styled.StyledMenuItem>
)

export { ChatActionItem }
